<template>
  <div id="featured-partner-container">
    <div id="featured-partners">
      <div id="carousel-container">
        <div id="carousel-header">Featured Partners</div>
        <LoaderComponent v-if="!loaded" />
        <transition-group v-else id="carousel" tag="div" name="carousel">
          <div
            class="featured-partner"
            v-for="partner in partners"
            :key="partner.links[1].href"
            v-show="partner.show"
          >
            <!-- v-if to avoid errors in console for "undefined" before data loads -->
            <div class="image-container" v-if="partner.pictures">
              <img class="featured-image" :src="partner.pictures[0].M" />
            </div>
            <div class="featured-information">
              <p class="featured-name">{{ partner.partnerName }}</p>
              <p class="featured-location">
                <span v-if="partner.city">{{ partner.city }}, </span
                >{{ partner.countryName }}
              </p>
              <p class="featured-description" v-html="partner.description"></p>
              <p class="featured-read-more">
                <router-link
                  class="featured-profile"
                  :to="{
                    name: 'partner',
                    params: {
                      database: partner.projectId,
                      country: partner.countryId,
                      id: partner.partnerId,
                      language: partner.languageId,
                    },
                  }"
                >
                  Read more &gt;&gt;
                </router-link>
              </p>
              <p class="featured-view-objects">
                <router-link
                  class="featured-objects"
                  :to="{
                    name: 'partner-objects',
                    params: {
                      database: partner.projectId,
                      country: partner.countryId,
                      id: partner.partnerId,
                      page: 1,
                    },
                  }"
                >
                  View objects &gt;&gt;
                </router-link>
              </p>
            </div>
          </div>
        </transition-group>
        <div id="carousel-controls">
          <span
            class="slideshow-bullet"
            v-for="(partner, index) in partners"
            :key="partner.links[1].href"
            @click="resetTimerOnClick(index)"
            :class="{ highlight: partners[index].show }"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import LoaderComponent from "./LoaderComponent.vue";
export default {
  name: "FeaturedPartners",
  components: {
    LoaderComponent: LoaderComponent,
  },
  data() {
    return {
      loaded: false,
      partners: {},
      interval: "",
      timeout: "",
    };
  },
  methods: {
    // Get list of featured partners
    loadPartners: function () {
      return axios({
        method: "GET",
        url: `${process.env.VUE_APP_DXA_ENDPOINT}/partners/featured?hash=${process.env.VUE_APP_API_HASH}`,
      }).then(
        (result) => {
          this.partners = result.data.items;
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // Get additional partner information for display
    getPartnerInformation: function () {
      for (let i = 0; i < this.partners.length; i++) {
        axios({ method: "GET", url: `${this.partners[i].links[1].href}` }).then(
          (result) => {
            // this.$set(this.partners, i, result.data);
            this.partners[i] = result.data;
            if (i === 0) {
              // this.$set(this.partners[i], "show", true);
              this.partners[i].show = true;
            } else {
              // this.$set(this.partners[i], "show", false);
              this.partners[i].show = false;
            }
            this.loaded = true;
          },
          (error) => {
            console.error(error);
          }
        );
      }
      // After content has loaded, call function for slide timer
      this.$nextTick(function () {
        this.advanceSlide(0);
      });
    },
    // Hide/show partners on a timer
    advanceSlide: function (index) {
      let slide = index;
      this.interval = setInterval(() => {
        if (slide < this.partners.length - 1) {
          this.showPartner(slide + 1);
          slide += 1;
        } else {
          slide = 0;
          this.showPartner(slide);
        }
      }, 8000);
    },
    // Hide partners, show next in rotation
    showPartner: function (index) {
      for (let i = 0; i < this.partners.length; i++) {
        this.partners[i].show = false;
      }
      this.partners[index].show = true;
    },
    // If a slide "dot" is clicked, reset the timer
    resetTimerOnClick: function (index) {
      clearTimeout(this.timeout);
      clearInterval(this.interval);
      this.showPartner(index);
      this.timeout = setTimeout(() => {
        this.advanceSlide(index);
      }, 2000);
    },
  },
  created() {
    this.loadPartners().then(this.getPartnerInformation);
  },
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#featured-partner-container {
  width: 100%;
  color: $light-text;
  background-color: $theme-medium;
}

#featured-partners {
  @include flex-center;
  width: 100%;
}

#carousel-container {
  @include flex-center;
  flex-direction: column;
  width: 100%;
}
#carousel-header {
  font-size: 125%;
  margin: 40px 0 20px 0;
  // Match sizing to image and descriptive text, include 20px of margin
  width: calc(60% + 20px);
}
.loader-container {
  background-color: $theme-medium;
  min-height: 275px;
}
:deep(.loader) {
  border-top: 5px solid $theme-medium-dark;
}
#carousel {
  position: relative;
  overflow: hidden;
  height: 32vh;
  max-height: 275px;
  width: 100%;
}
.featured-partner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  @include flex-center;
  height: 100%;
  width: 100%;
}
// Classes for transition-group
// (Animations)
.carousel-enter-active,
.carousel-leave-active {
  transition: all 1s;
}
.carousel-enter,
.carousel-leave-to {
  opacity: 0;
}
.image-container {
  @include flex-center;
  height: 100%;
  width: 30%;
  margin-right: 10px;
}
.featured-image {
  @include image-scale;
  object-fit: cover;
}
.featured-information {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  // align-items: flex-start;
  align-items: stretch;
  height: 100%;
  width: 30%;
  margin-left: 10px;
}
.featured-name {
  justify-self: start;
  font-weight: bold;
  width: 100%;
}
.featured-location {
  font-style: italic;
  width: 100%;
}
.featured-description {
  position: relative;
  height: 6em;
  overflow: hidden;
  margin-top: 20px;
  line-height: 1.2em;
}
// "Fade" out text for longer paragraphs
.featured-description:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 1.2em;
  width: 70%;
  background: linear-gradient(
    to right,
    rgba($theme-medium, 0),
    rgba($theme-medium, 1) 50%
  );
}
.featured-read-more {
  margin-top: 5px;
}
.featured-read-more,
.featured-view-objects {
  width: 100%;
  text-align: right;
}
.featured-profile,
.featured-objects {
  text-decoration: none;
  color: $light-text;
}
.featured-profile:hover,
.featured-objects:hover {
  text-decoration: underline;
}

#carousel-controls {
  @include flex-center;
  justify-content: flex-start;
  // Match sizing to image and descriptive text, include 20px of margin
  width: calc(60% + 20px);
  margin: 20px 0 40px 0;
}
.slideshow-bullet {
  height: 14px;
  width: 14px;
  border-radius: 100%;
  background-color: $theme-dark;
  margin-right: 18px;
  cursor: pointer;
}
.highlight {
  background-color: $theme-light;
}

@media only screen and (max-width: 1199px) {
  #carousel-header {
    font-size: 115%;
  }
  .featured-information {
    font-size: 95%;
  }
}

@media only screen and (max-width: 974px) {
  #carousel-header {
    // Match sizing to image and descriptive text, include 20px of margin
    width: calc(80% + 20px);
  }
  #carousel {
    height: 36vh;
  }
  .image-container {
    width: 40%;
  }
  .featured-information {
    width: 40%;
  }
  #carousel-controls {
    // Match sizing to image and descriptive text, include 20px of margin
    width: calc(80% + 20px);
  }
}

@media only screen and (max-width: 724px) {
  #carousel-header {
    font-size: 105%;
    margin-top: 25px;
  }
  #carousel {
    height: 30vh;
    max-height: 200px;
  }
  #carousel-controls {
    margin-bottom: 25px;
  }
}

@media only screen and (max-width: 599px) {
  #carousel-header {
    margin-top: 18px;
  }
  #carousel {
    height: 500px;
    max-height: none;
  }
  .featured-partner {
    flex-direction: column;
  }
  .image-container {
    height: 60%;
    width: calc(80% + 20px);
    padding-bottom: 18px;
    margin-right: 0;
  }
  .featured-information {
    height: 40%;
    width: calc(80% + 20px);
    margin-left: 0;
  }
  #carousel-controls {
    margin-bottom: 18px;
  }
}

@media only screen and (max-width: 499px) {
  #carousel {
    height: 400px;
  }
  .image-container {
    height: 50%;
  }
  .featured-information {
    height: 50%;
  }
}
</style>